"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../Button/Button"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var Tab =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Tab, _Component);

  function Tab() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Tab)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onClick", function (evt) {
      var _this$props = _this.props,
          index = _this$props.index,
          onTabClick = _this$props.onTabClick;
      onTabClick(index);
    });
    return _this;
  }

  (0, _createClass2.default)(Tab, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          active = _this$props2.active;
      var classes = (0, _classnames.default)('Tab', {
        'Tab-active': active
      }, className);
      return _react.default.createElement(_Button.default, {
        className: classes,
        role: "tab",
        onClick: this._onClick
      }, children);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Tab;
}(_react.Component);

exports.default = Tab;
(0, _defineProperty2.default)(Tab, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The content to render inside of the tab. */
  children: _propTypes.default.node.isRequired,

  /** The label to put in the dropdown when the tabs are on small viewports. Not used in this component but gets read in TabNavigation to create the dropdown. */
  label: _propTypes.default.string.isRequired,
  // eslint-disable-line react/no-unused-prop-types

  /** Whether this tab should be active. Automatically passed from TabNavigation, do not set manually. */
  active: _propTypes.default.bool,

  /** The method to call when this tab is clicked. Automatically passed from TabNavigation, do not set manually. */
  onTabClick: _propTypes.default.func,

  /** The index that corresponds to this tab. Automatically passed from TabNavigation, do not set manually. */
  index: _propTypes.default.number
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Tab, "Tab", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Tabs/Tab.jsx");
  leaveModule(module);
})();

;